// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules_dev/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login-wrapper[data-v-04fdcdb6]{min-height:calc(100vh - 250px);display:flex;justify-content:center;align-items:center}", ""]);
// Exports
module.exports = exports;
